import { render, staticRenderFns } from "./Wave.vue?vue&type=template&id=066f6ac1&scoped=true&"
import script from "./Wave.vue?vue&type=script&lang=js&"
export * from "./Wave.vue?vue&type=script&lang=js&"
import style0 from "./Wave.vue?vue&type=style&index=0&id=066f6ac1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f6ac1",
  null
  
)

export default component.exports